import { Skeleton } from 'antd';
import { Column, Icon, Space, Text, Tooltip } from 'farmhub-ui-core';

import { theme } from 'styled';
import { ICONS } from 'utils/constants';

import * as S from './styles';

const CheckFilterItemDesktop = ({
  selected = false,
  image,
  tooltip,
  width,
  height,
  typeSelectCreate = false,
  handleClick,
}: CheckFilterItemProps): JSX.Element => (
  <S.Wrapper
    height={height}
    selected={selected}
    typeSelectCreate={typeSelectCreate}
    width={width}
    onClick={handleClick}
  >
    <Column alignItems="center">
      <S.ImageWrapper>
        {image ? (
          <S.Image src={image} />
        ) : (
          <Skeleton.Image style={{ width: '100%', height: '48px' }} />
        )}
      </S.ImageWrapper>
      <Space height={6} />
      <Tooltip title={tooltip}>
        <Text
          lineNumber={2}
          size="xxs"
          styles={{
            'text-align': 'center',
            color:
              selected && typeSelectCreate
                ? theme.colors.primary.main
                : theme.colors.text.primary,
          }}
          weight="medium"
        >
          {tooltip}
        </Text>
      </Tooltip>
    </Column>
    {selected && !typeSelectCreate && (
      <Icon
        styles={S.IconStyles}
        svgProps={{
          icon: ICONS.TICK,
          color: theme.colors.primary.main,
          width: '18px',
          height: '18px',
        }}
      />
    )}
  </S.Wrapper>
);

export default CheckFilterItemDesktop;

export interface CheckFilterItemProps {
  image: string;
  tooltip: string;
  selected?: boolean;
  width?: string;
  height?: string;
  typeSelectCreate?: boolean;
  handleClick?: () => void;
}

export const CheckFilterItemSkeleton = ({
  width,
  height,
}: CheckFilterItemSkeletonProps): JSX.Element => (
  <S.Wrapper height={height} selected={false} width={width}>
    <Column alignItems="center">
      <S.ImageWrapper>
        <Skeleton.Avatar shape="square" size={48} />
      </S.ImageWrapper>
      <Space height={12} />
      <Skeleton.Input size="small" style={{ width: '100%' }} />
    </Column>
  </S.Wrapper>
);

export interface CheckFilterItemSkeletonProps {
  width?: string;
  height?: string;
}
